// src/components/common/DashboardLayout/DashboardLayout.js
import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import Sidebar from '../Sidebar/Sidebar';
import { COLORS } from '../../../utils/color';

const SIDEBAR_WIDTH = 280;
const COLLAPSED_WIDTH = 70;

const MainContainer = styled(Box)({
  display: 'flex',
  minHeight: '100vh',
  backgroundColor: '#000000',
});

const ContentArea = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'sidebarOpen' && prop !== 'isMobile',
})(({ sidebarOpen, isMobile }) => ({
  flex: 1,
  marginLeft: isMobile ? 0 : (sidebarOpen ? `${SIDEBAR_WIDTH}px` : `${COLLAPSED_WIDTH}px`),
  minHeight: '100vh',
  backgroundColor: '#000000',
  overflow: 'auto',
  transition: 'margin-left 0.28s ease',
}));

const DashboardLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  // Sync with mobile state
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [isMobile]);

  // Listen for sidebar state changes
  useEffect(() => {
    const handleSidebarStateChange = (event) => {
      setSidebarOpen(event.detail.isOpen);
    };

    window.addEventListener('sidebarStateChange', handleSidebarStateChange);
    
    return () => {
      window.removeEventListener('sidebarStateChange', handleSidebarStateChange);
    };
  }, []);

  return (
    <MainContainer>
      <Sidebar onStateChange={setSidebarOpen} />
      <ContentArea 
        sidebarOpen={sidebarOpen} 
        isMobile={isMobile}
        data-content-area="true"
      >
        {children}
      </ContentArea>
    </MainContainer>
  );
};

export default DashboardLayout;